<template>
    <div>
        <div v-if='ready' class='detail'>
            <div>
                <!--Process each order -->
                <archival-collection-detail v-if='object._index == "archival_collection"' :object='object'></archival-collection-detail>
                <archival-series-detail v-else-if='object._index == "archival_series"' :object='object'></archival-series-detail>
                <archival-file-unit-detail v-else-if='object._index == "archival_fileunit"' :object='object'></archival-file-unit-detail>
                <archival-item-detail v-else-if='object._index == "archival_item"' :object='object'></archival-item-detail>
                <collection-detail v-else-if='object._index == "mariners_collection" || object._index == "monitor_collection"' :object='object'></collection-detail>
                <library-detail v-else-if='object._index == "library"' :object='object'></library-detail>
                <exhibit-detail v-else-if='object._index == "exhibit"' :object='object'></exhibit-detail>
                <association-detail v-else-if='object._index == "association"' :object='object'></association-detail>
                <vessel-detail v-else-if='object._index == "vessel"' :object='object'></vessel-detail>
            </div>
        </div>
        <div v-else>
            <div class='loader'>
                <img src="/images/mariners-loading-icon.gif" width='35px'>
            </div>
        </div>
    </div>
</template>

<script>
    import ArchivalCollectionVue from './details/archivalCollectionDetail.vue'
    import ArchivalSeriesVue from './details/archivalSeriesDetail.vue'
    import ArchivalFileUnitVue from './details/archivalFileUnitDetail.vue'
    import ArchivalItemVue from './details/archivalItemDetail.vue'
    import CollectionDetailVue from './details/collectionDetail.vue'
    import LibraryDetailVue from './details/libraryDetail.vue'
    import ExhibitDetailVue from './details/exhibitDetail.vue'
    import AssociationDetailVue from './details/associationDetail.vue'
    import VesselDetailVue from './details/vesselDetail.vue'
    import MediaParser from '../mixins/mediaParser.js'
    import EventHub from './eventHub.js'

    export default {
        mixins: [MediaParser],
        data: function () {
            return {
                object: {},
                images: [],
                not_found: false,
                ready: false,
            }
        },
        mounted: function () {
            var self = this
            EventHub.$on('load-object', function (id) {
                self.loadObject(null, null, id)
            })

            // When the component is mounted fetch search data
            this.$nextTick(function () {
                this.loadObject()
            })
        },
        beforeDestroy: function () {
            EventHub.$off('load-object')
        },
        methods: {
            // To maintain the scroll location in the search route when viewing an object
            // the object route is a nested route in the search route.
            // As a consequence, if you want to go from one object to another
            // without reloading the search route you have to manually fetch the new object
            // and manually change the url
            loadObject: function (to, from, id) {
                var self = this
                this.ready = false
                id = typeof id !== 'undefined' ? id : this.$route.params.id

                // Fetch the url given (either manually or through the route param)
                $.get('/api/object/' + id).done(function (response) {
                    if (response.results.length == 0) {
                        window.location.href = '/404'
                    } else {
                        self.object = response.results[0]._source
                        self.object._index = response.results[0]._index
                        self.object._id = response.results[0]._id

                        // Update document title
                        window.document.title = self.object.searchable.title[0] + " - The Mariners' Museum Online Catalog"
                        $('meta[name=description]').attr('content', self.object.description)
                        window.document.description = self.object.description

                        // Sort label order
                        if (self.object.order) {
                            self.object.order = _.sortBy(self.object.order, ['order'])
                        }
                    }

                    self.ready = true
                })

                // Insure the url matches the object being loaded
                window.history.replaceState(null, '', '/object/'+id)
            }
        },
        watch: {
            '$route': 'loadObject'
        },
        components: {
            'archival-collection-detail': ArchivalCollectionVue,
            'archival-series-detail': ArchivalSeriesVue,
            'archival-file-unit-detail': ArchivalFileUnitVue,
            'archival-item-detail': ArchivalItemVue,
            'collection-detail': CollectionDetailVue,
            'library-detail': LibraryDetailVue,
            'exhibit-detail': ExhibitDetailVue,
            'association-detail': AssociationDetailVue,
            'vessel-detail': VesselDetailVue,
        }
    }
</script>

<style lang="scss">
    @import '../../sass/variables.scss';

    .detail {
        padding-bottom: 100px;

        /* apply if less than 992px (bootstrap large) */
        @media (max-width: 992px) {
            padding-left: 15px;
            padding-right: 15px;
        }

        .row {
            padding-bottom: 5px;
            padding-top: 5px;
            padding-left: 0px;
            padding-right: 0px;
        }

        /* For SEO use h1 instead of h4 */
        h1 {
            color: $blue;
            font-size: 18px;
        }
    }
</style>
